<template>
    <GuestLayout>
        <div class="card" style="width: 350px">
            <LoginCard v-if="step === 'login'" @forgot-password="step = 'forgot'"/>
            <ForgotPasswordCard v-else-if="step === 'forgot'" @code-sent="codeSent"/>
            <ResetPasswordCard v-else-if="step === 'reset'" :email="email" @password-reset="step = 'login'"/>
        </div>
    </GuestLayout>
</template>

<script>
import GuestLayout from "../../../layouts/GuestLayout.vue";
import LoginCard from "./cards/LoginCard.vue";
import ForgotPasswordCard from "./cards/ForgotPasswordCard.vue";
import ResetPasswordCard from "./cards/ResetPasswordCard.vue";

export default {
    name: "AuthenticationPage",
    components: {
        GuestLayout,
        LoginCard,
        ForgotPasswordCard,
        ResetPasswordCard,
    },
    data() {
        return {
            step: 'login',
            email: null,
        }
    },
    methods: {
        codeSent(email) {
            this.email = email;
            this.step = 'reset';
        },
    },
}
</script>
